import Vue from "vue";
import Vuex from "vuex";

import User from "@/api/user";
import Chat from "@/api/chat";
import Utils from "@/utils/";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: "",
    userId: "",
    nickName: "",
    tabIndex: "0",
    isHubInit: false,
    // 用户信息
    info: {
      avatar: "",
      companyId: "",
      userId: "",
      userName: "",
      nickName: "",
      onlineNum: 0,
      beansNum: 0
    },
    // 私聊聊天记录
    privateChat: {
      id: "",
      info: {},
      pageIndex: 1,
      totalCount: 0,
      messageList: [],
      msgIdList: []
    },
    isAnonymous: false,
    onlineList: [],
    // 大厅聊天记录
    messageList: [],
    // 私聊列表
    conversation: [],
    // 用于去重
    msgIdList: [],
    balance: 0,
    chatScroll: 0,
    advert: null,
    broadcast: {
      msgId: "",
      txt: ""
    },
    redList: [],
    redEnvelopeInfo: {},
    inform: {
      message: 0,
      at: 0,
      topic: []
    }
  },
  getters: {
    // 未读消息数
    unreadNum(state) {
      let num = 0;

      state.conversation.map(item => {
        num += item.unread;
      });
      return num;
    }
  },
  mutations: {
    // 切换匿名
    toggleAnonymous(state) {
      state.isAnonymous = !state.isAnonymous;
      User.updateChatInfo({ IsAnonymousSending: state.isAnonymous });
    },
    // 切换大厅和私聊的选型
    setTabIndex(state, value) {
      state.tabIndex = value;
    },
    // 从大厅离开的时候缓存当前页面高度
    setChatScroll(state, value) {
      if (value === 0) {
        state.chatScroll = undefined;
      }
      state.chatScroll = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
    },
    // 设置在线人数
    setOnlineNum(state, data) {
      state.onlineNum = data ? data : state.onlineNum + 1;
    },
    // 收到有人上线的消息插入
    addOnline(state, data) {
      state.onlineList.push({
        userId: data.userId,
        userName: data.userName,
        companyId: data.companyId,
        companyName: data.companyName
      });
    },
    // 轮播完弹出
    shiftOnline(state) {
      if (state.onlineList.length) {
        state.onlineList.shift();
      }
    },
    // 更新用户信息
    updateUserInfo(state, info) {
      state.info = Object.assign({}, state.info, info);
    },
    cleanCache(state) {
      state.redList = [];
      state.messageList = [];
      state.msgIdList = [];
      state.redEnvelopeInfo = {};
    },
    // APP连接创建初始化完时改变状态
    setHubStatus(state) {
      state.isHubInit = true;
    },
    // 设置当前的红包信息，一般是后端广播红包消息时直接调用
    setRedEnvelope(state, info) {
      state.redEnvelopeInfo = info;
    },
    // 后面需求不考虑同事存在多个红包的情况，最新的红包显示即可
    addRedList(state, info) {
      state.redList.push(info);
    },
    updateMessage(state, { msgId, update }) {
      const index = state.messageList.findIndex(item => item.msgId === msgId);
      state.messageList[index] = Object.assign({}, state.messageList[index], update);
    },
    // 设置广播轮播
    setBroadcast(state, broadcast) {
      state.broadcast = broadcast;
    },
    // 清除大厅的消息列表
    clearMessageList(state) {
      state.messageList = [];
      state.msgIdList = [];
    },
    // 添加到消息列表
    addToMessageList(state, { message, type, list = [] }) {
      let messageList = state.messageList;
      let msgIdList = state.msgIdList;
      if (message && message.conversationId) {
        if (state.privateChat.id !== message.conversationId) {
          const item = state.conversation.find(item => item.conversationId === message.conversationId);
          Vue.set(item, "unread", item.unread + 1);
          Vue.set(item, "lastmsg", message);
        } else {
          state.privateChat.messageList.push(message);
          state.privateChat.msgIdList.push(message.msgId);
        }
        return true;
      }
      if (message) {
        list.push(message);
      }
      list.map(item => {
        item = formatMsg(item, type);
        if (msgIdList.includes(item.msgId)) {
          return false;
        }
        // 以后优化,每次都会遍历现有的列表,而且一般最新的，时间戳最大都在最后面
        const index = messageList.findIndex(listItem => listItem.t >= item.t);
        if (index === -1) {
          messageList.push(item);
        } else {
          messageList.splice(index, 0, item);
        }
        msgIdList.push(item.msgId);
      });
      // eslint-disable-next-line no-unused-vars
      function formatMsg(msg, type) {
        msg.time = Utils.timeFormat(msg.t);
        // if (msg.redEnvelopeId || msg.msgType === 3) {
        //   msg.msgType = 3;
        //   msg.redEnvelopeOver = msg.redEnvelopeOver || false;
        //   msg.getAmount = msg.getAmount || 0;
        // } else if (msg.tags && !msg.replyId) {
        //   msg.msgType = 2;
        // } else {
        //   msg.msgType = 1;
        // }
        return msg;
      }
    },
    // 私聊消息，其实跟公共消息类似，只是每次都会清空
    setPrivateChat(state, info) {
      state.privateChat = {
        id: info.id || "",
        info,
        messageList: [],
        msgIdList: [],
        pageIndex: 1,
        totalCount: 0
      };
    },
    // 更新ERP外部的按钮提示数量，现在这个需求砍掉了
    updateInform(state, { key, value }) {
      state.inform[key] = value === undefined ? state.inform[key] + 1 : value;
      window.cefQuery &&
        window.cefQuery({
          request: "setInformNumber",
          data: JSON.stringify({
            message: state.inform.message,
            at: state.inform.at
          }),
          persistent: false
        });
    },
    // 撤回消息
    withdrawMessage(state, msgId) {
      const index = state.messageList.findIndex(item => Number(item.msgId) === Number(msgId));
      state.messageList.splice(index, 1);
    },
    // 系统提示原来是指会出现在聊天界面上的消息，现在已经砍掉了，改成弹窗提示
    addSystemMessage(state, { message, type }) {
      message.t = message.t || Date.now();
      message.type = type;
      message.link = { path: "/" };
      this.commit("addToMessageList", message);
    }
  },
  actions: {
    async userLogin({ state }, { account, password } = {}) {
      this.commit("cleanCache");
      if (window.cefQuery) {
        window.cefQuery({
          request: "getErpAuthInfo",
          data: "{}",
          onSuccess: res => {
            res = JSON.parse(res);
            state.token = res.AccessionToken;
            const info = {
              userId: res.UserGuid,
              avatar: res.AvatarUrl,
              companyId: res.CompanyID,
              companyName: res.CompanyName,
              userName: res.UserName
            };
            state.userId = res.UserGuid;
            state.info = info;
          },
          onFailure: (code, err) => {
            console.log(code, err);
          },
          persistent: false
        });
      } else if (account && password) {
        const data = await User.login(account, password);
        state.token = data.AccessionToken;
        state.userId = data.UserGuid;
        state.info = {
          userId: data.UserGuid,
          avatar: data.AvatarUrl,
          companyId: data.CompanyID,
          companyName: data.CompanyName,
          userName: data.UserName
        };
      }
    },
    // 获取广告轮播
    async getAdvert({ state }) {
      await Chat.getAdvert()
        .then(res => {
          state.advert = res ? { url: res.ImageUrl, link: res.JumpUrl } : null;
        })
        .catch(() => {
          state.advert = {
            url: "",
            link: ""
          };
        });
    },
    // 获取用户能量豆余额是否匿名之类的
    async getChatInfo({ state }) {
      const result = await User.getChatInfo();
      state.beansNum = result.Beans;
      state.balance = result.MyBalance;
      state.isAnonymous = result.IsAnonymousSending;
    },
    // 创建私聊会话
    getConversations({ state }) {
      $.connection.chatConversationHub.server.getConversations().then(res => {
        state.conversation = res || [];
      });
    },
    // 获取私聊聊天记录
    async getLastChatRecords({ state }, { conversationId, pageIndex = 1, pageSize = 50, lastMsgId = "" }) {
      state.privateChat.pageIndex = pageIndex;
      const result = await $.connection.chatConversationHub.server.getLastChatRecords({
        conversationId,
        pageIndex,
        pageSize,
        lastMsgId
      });
      const messageList = state.privateChat.messageList;
      const msgIdList = state.privateChat.msgIdList;
      result.ResultList &&
        result.ResultList.map(item => {
          if (msgIdList.includes(item.msgId)) {
            return false;
          }
          const index = messageList.findIndex(listItem => listItem.t >= item.t);
          if (index === -1) {
            messageList.push(item);
          } else {
            messageList.splice(index, 0, item);
          }
          msgIdList.push(item.msgId);
        });
      state.privateChat.messageList = messageList;
      state.privateChat.msgIdList = msgIdList;
      state.privateChat.totalCount = result.TotalCount;
      return result;
    }
  },
  modules: {}
});
